
















import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import { Route } from 'vue-router'

import PreviewNotification from '@/components/organisms/PreviewNotification.vue'
import { log } from '@/log'
import { StatusServiceFactory } from '@/services/api/status'
import { getZealsMeta } from '@/util/html-meta'
import { extractBrand } from '@spa/router/hooks/lib/extract'

interface AppStatus {
  maintenance: {
    enabled: boolean
    html?: string
  }
}

// 現行defaultで存在するプロパティにしか型定義をできないため、anyで受けている
@Component<any>({
  components: {
    PreviewNotification,
  },
  head: {
    meta: [
      ...getZealsMeta(),
    ],
  },
})
export default class SpaApp extends Vue {
  appStatus: AppStatus = this.initialStatus
  checkingMaintenanceMode: boolean = false

  get showMainContents(): boolean {
    return !this.appStatus.maintenance.enabled && !this.checkingMaintenanceMode
  }

  get isLoading(): boolean {
    return this.$store.state.view.isLoading
  }

  get _class() {
    return {
      'l-spa-adjust--loading': this.isLoading,
    }
  }

  /*
   * App.vueはvue-routerによる描画切り替えを使う側であって、
   * vue-routerによって切り替えられる側（＝各種フックを呼ばれる側）ではない.
   * そのため、このVueコンポーネントでbeforeRouteEnterを定義しても実行されない.
   *
   * beforeRouteEnterなど、ナビゲーションガードを使う方法も検討したが、
   * 上記の理由で$routeをwatchする方法で代用している.
   * https://github.com/my-color/front/pull/6869#discussion_r1085022422
   *
   * https://github.com/my-color/front/issues/1284 では検討されていなかったが、
   * そもそもとして、「メンテナンス状態」をApp.vueで管理するのではなくVuexストアで管理した方が良いかもしれない.
   * - メンテナンス状態をVuexで管理
   * - App.vueはVuex経由でメンテナンス状態を参照し、レンダリング内容を決める
   * - vue-routerのルーティングに、「メンテナンス状態をチェックして、結果をVuexに通知」を行うフックを登録
   *   - グローバルフックか、ページによって扱いを返る必要があるなら require-login のようにmetaデータを使っても良いか
   *
   * 「メンテナンス状態」はSPA全体で共有されてしかるべきデータであるため、むしろVuexに配置した方が意味的にも妥当そう
   */
  @Watch('$route', { immediate: true })
  async handleBrandMaintenanceMode(current: Route) {
    if (this.checkingMaintenanceMode) {
      return
    }

    await this.startCheckMaintenance()

    const brand = extractBrand(current)
    if (!brand) {
      this.appStatus = this.initialStatus
      await this.finishCheckMaintenance()

      return
    }

    const maintenanceStatusResult = await StatusServiceFactory.create().brandMaintenance(brand)

    maintenanceStatusResult.fold(
      (error) => {
        log.error({ error })

        this.appStatus = this.initialStatus
      },
      status => this.appStatus = {
        maintenance: {
          enabled: status.maintenance,
          html: status.html,
        },
      }
    )
    await this.finishCheckMaintenance()
  }

  private get initialStatus(): AppStatus {
    return {
      maintenance: {
        enabled: false,
        html: '',
      },
    }
  }
  private async startCheckMaintenance() {
    this.checkingMaintenanceMode = true
    await this.$store.dispatch('view/startLoading')
  }
  private async finishCheckMaintenance() {
    this.checkingMaintenanceMode = false
    await this.$store.dispatch('view/stopLoading')
  }
}
